(function () {
  var selectors = {
    cartCount: '[data-onyx-nav-cart-count]',
    cartCountValue: '[data-cart-render="item_count"]',
    menu: '[data-onyx-nav-menu]',
    menuDropdown: '[data-onyx-nav-menu-dropdown]',
    menuGroupItem: '[data-onyx-nav-menu-group-item]',
    menuGroups: '.groups',
    menuPanel: '[data-onyx-nav-menu-panel]',
    menuPanels: '[data-onyx-nav-menu-panels]',
    menuTrigger: '[data-onyx-nav-menu-trigger]',
    searchInput: '[data-onyx-nav-search-input]',
    searchToggle: '[data-onyx-nav-search-toggle]',
    toggle: '[data-onyx-nav-toggle]',
  };

  var mobileQuery = window.matchMedia('(max-width: 800px)');
  var roots = document.querySelectorAll('[data-onyx-nav]');

  /*
    NAV OPEN / CLOSE CONTROLLER
    This block is solely responsible for keeping the `.open` state in sync
    between `.onyx-nav` and `.onyx-nav-menu`. Both the search button and menu
    button toggle the same source of truth so the two elements cannot drift
    into separate open/closed states.
  */
  function getNavMenu(root) {
    var header = root.closest('.onyx-header');
    var headerSibling = header ? header.nextElementSibling : null;

    if (headerSibling && headerSibling.matches(selectors.menu)) {
      return headerSibling;
    }

    return document.querySelector(selectors.menu);
  }

  function isNavOpen(root, menu) {
    return root.classList.contains('open') || Boolean(menu && menu.classList.contains('open'));
  }

  function setNavOpen(root, menu, isOpen) {
    var menuToggle = root.querySelector(selectors.toggle);

    root.classList.toggle('open', isOpen);
    root.toggleAttribute('data-onyx-nav-menu-open', isOpen);

    if (menu) {
      menu.classList.toggle('open', isOpen);
    }

    if (menuToggle) {
      menuToggle.classList.toggle('active', isOpen);
      menuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }
  }

  function focusSearchInput(root) {
    var searchInput = root.querySelector(selectors.searchInput);

    if (!searchInput) {
      return;
    }

    try {
      searchInput.focus({ preventScroll: true });
    } catch (error) {
      searchInput.focus();
    }
  }

  function isProtectedNavClick(root, menu, header, target) {
    return (
      root.contains(target) ||
      Boolean(menu && menu.contains(target)) ||
      Boolean(header && header.contains(target))
    );
  }

  function initNavOpenToggle(root) {
    var header = root.closest('.onyx-header') || root.closest('header');
    var menu = getNavMenu(root);
    var toggles = root.querySelectorAll([selectors.searchToggle, selectors.toggle].join(','));

    setNavOpen(root, menu, isNavOpen(root, menu));

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var shouldOpen = !isNavOpen(root, menu);

        setNavOpen(root, menu, shouldOpen);

        if (shouldOpen && toggle.matches(selectors.searchToggle)) {
          focusSearchInput(root);
        }
      });
    });

    document.addEventListener('click', function (event) {
      if (!isNavOpen(root, menu) || isProtectedNavClick(root, menu, header, event.target)) {
        return;
      }

      setNavOpen(root, menu, false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !isNavOpen(root, menu)) {
        return;
      }

      setNavOpen(root, menu, false);
    });
  }

  function getCartCountRatio(value) {
    var count = String(value || '0').replace(/[^0-9]/g, '');

    return count.length >= 3 ? '1.5 / 1' : '1 / 1';
  }

  function getCartCountQuantity(value) {
    var count = String(value || '0').replace(/[^0-9]/g, '');

    if (!count.length) {
      return 0;
    }

    return parseInt(count, 10);
  }

  function syncCartCountRatio(cartCount) {
    var countValue = cartCount.querySelector(selectors.cartCountValue);
    var count = countValue ? countValue.textContent : cartCount.textContent;

    cartCount.style.setProperty('--cart-count-ratio', getCartCountRatio(count));
    cartCount.style.display = getCartCountQuantity(count) > 0 ? '' : 'none';
  }

  function initCartCount(root) {
    var cartCount = root.querySelector(selectors.cartCount);

    if (!cartCount) {
      return;
    }

    syncCartCountRatio(cartCount);

    if (!window.MutationObserver) {
      return;
    }

    var countValue = cartCount.querySelector(selectors.cartCountValue) || cartCount;
    var observer = new MutationObserver(function () {
      syncCartCountRatio(cartCount);
    });

    observer.observe(countValue, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  /*
    SAFE-TRIANGLE HOVER INTENT ("menu-aim")
    Vanilla JS port of the jQuery-menu-aim algorithm (MIT):
    https://github.com/kamens/jQuery-menu-aim

    Only DESKTOP pointer movement goes through this; mobile accordion taps
    and keyboard focus activate directly (see MENU PANEL CONTROLLER below).
  */
  function createMenuAim(groupsColumn, onActivate) {
    var MOUSE_LOCS_TRACKED = 3; // Mouse positions kept in the trail.
    var ACTIVATION_DELAY = 300; // ms between intent re-checks while aiming at the panel.
    var EDGE_TOLERANCE = 75; // px added above/below the panel edge to widen the triangle.
    var mouseLocs = [];
    var lastDelayLoc = null;
    var timeoutId = null;

    // 1. MOUSE TRAIL: record recent cursor positions (page coordinates).
    document.addEventListener('mousemove', function (event) {
      mouseLocs.push({ x: event.pageX, y: event.pageY });

      if (mouseLocs.length > MOUSE_LOCS_TRACKED) {
        mouseLocs.shift();
      }
    });

    function slope(a, b) {
      return (b.y - a.y) / (b.x - a.x);
    }

    /*
      2. TRIANGLE / SLOPE TEST
      Returns the delay (ms) to wait before re-checking intent, or 0 when
      the hovered group should activate right away.
    */
    function activationDelay() {
      var rect = groupsColumn.getBoundingClientRect();
      var left = rect.left + window.scrollX;
      var top = rect.top + window.scrollY;
      var right = left + rect.width;
      var bottom = top + rect.height;

      // The panel opens to the right, so the triangle's base is the groups
      // column's right edge, extended vertically by the tolerance.
      var upperRight = { x: right, y: top - EDGE_TOLERANCE };
      var lowerRight = { x: right, y: bottom + EDGE_TOLERANCE };

      var loc = mouseLocs[mouseLocs.length - 1];
      var prevLoc = mouseLocs[0] || loc;

      if (!loc) {
        return 0;
      }

      // Cursor just entered from outside the groups column: activate
      // instantly, there is no travel path to protect yet.
      if (
        prevLoc.x < left ||
        prevLoc.x > right ||
        prevLoc.y < top - EDGE_TOLERANCE ||
        prevLoc.y > bottom + EDGE_TOLERANCE
      ) {
        return 0;
      }

      // Cursor has not moved since the last delayed check: the user has
      // parked on this group on purpose, so honor the hover.
      if (lastDelayLoc && loc.x === lastDelayLoc.x && loc.y === lastDelayLoc.y) {
        return 0;
      }

      // Still converging on the panel edge? Keep the current panel open.
      if (
        slope(loc, upperRight) < slope(prevLoc, upperRight) &&
        slope(loc, lowerRight) > slope(prevLoc, lowerRight)
      ) {
        lastDelayLoc = loc;
        return ACTIVATION_DELAY;
      }

      lastDelayLoc = null;
      return 0;
    }

    function cancel() {
      if (timeoutId) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
    }

    /*
      3. RE-CHECK LOOP
      Called on trigger mouseenter. Either activates immediately, or keeps
      deferring while the cursor is aiming at the panel. Only the most
      recently hovered trigger ever has a pending activation.
    */
    function possiblyActivate(trigger) {
      cancel();

      var delay = activationDelay();

      if (delay) {
        timeoutId = setTimeout(function () {
          possiblyActivate(trigger);
        }, delay);
      } else {
        onActivate(trigger);
      }
    }

    return {
      possiblyActivate: possiblyActivate,
      cancel: cancel,
    };
  }

  /*
    MENU PANEL CONTROLLER
    This block powers the main menu (`.onyx-nav-menu`) group/panel behavior.
    Desktop: hovering/focusing a group button reveals its panel in the shared
    `.panels` column, with one panel always active. Hover activation is
    filtered through the SAFE-TRIANGLE HOVER INTENT block above so diagonal
    travel toward an open panel doesn't swap panels mid-flight.
    Mobile: each panel is physically moved into its group's `.mobile-panel-slot`
    so the groups behave as an accordion, with all panels closed by default.
  */
  function getMobileSlot(menu, panel) {
    return menu.querySelector('[data-onyx-nav-menu-mobile-slot="' + panel.id + '"]');
  }

  function initMenuDropdown(menu) {
    var triggers = menu.querySelectorAll(selectors.menuTrigger);
    var panelsContainer = menu.querySelector(selectors.menuPanels);
    var panels = menu.querySelectorAll(selectors.menuPanel);
    var groupsColumn = menu.querySelector(selectors.menuGroups);

    function setPanelState(panel, open) {
      var slot = getMobileSlot(menu, panel);
      var groupItem = slot ? slot.closest(selectors.menuGroupItem) : null;

      if (mobileQuery.matches) {
        panel.hidden = false;
        panel.setAttribute('aria-hidden', open ? 'false' : 'true');
        panel.toggleAttribute('inert', !open);

        if (slot) {
          slot.hidden = false;
          if (open) {
            slot.setAttribute('data-open', 'true');
          } else {
            slot.removeAttribute('data-open');
          }
        }

        if (groupItem) {
          if (open) {
            groupItem.setAttribute('data-open', 'true');
          } else {
            groupItem.removeAttribute('data-open');
          }
        }

        return;
      }

      panel.hidden = !open;
      panel.removeAttribute('aria-hidden');
      panel.removeAttribute('inert');

      if (slot) {
        slot.hidden = true;
        slot.removeAttribute('data-open');
      }

      if (groupItem) {
        groupItem.removeAttribute('data-open');
      }
    }

    function movePanels() {
      panels.forEach(function (panel) {
        var slot = getMobileSlot(menu, panel);
        var parent = mobileQuery.matches && slot ? slot : panelsContainer;

        if (parent && panel.parentElement !== parent) {
          parent.appendChild(panel);
        }
      });
    }

    function activate(trigger, allowToggle) {
      var panelId = trigger.getAttribute('aria-controls');
      var shouldOpen = true;

      if (allowToggle && trigger.getAttribute('aria-expanded') === 'true') {
        shouldOpen = false;
      }

      triggers.forEach(function (item) {
        item.setAttribute('aria-expanded', item === trigger && shouldOpen ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        setPanelState(panel, panel.id === panelId && shouldOpen);
      });
    }

    function resetMobilePanels() {
      triggers.forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      });

      panels.forEach(function (panel) {
        setPanelState(panel, false);
      });
    }

    function resetDesktopPanels() {
      var activeTrigger = Array.prototype.find.call(triggers, function (trigger) {
        return trigger.getAttribute('aria-expanded') === 'true';
      });

      activate(activeTrigger || triggers[0], false);
    }

    function syncLayout() {
      menuAim.cancel();
      movePanels();

      if (mobileQuery.matches) {
        resetMobilePanels();
      } else if (triggers.length) {
        resetDesktopPanels();
      }
    }

    // SAFE-TRIANGLE HOVER INTENT (see createMenuAim above): desktop hover
    // activation is deferred while the cursor is aiming at the open panel.
    var menuAim = createMenuAim(groupsColumn, function (trigger) {
      activate(trigger, false);
    });

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        // Clicks express clear intent, so they bypass the aim check.
        menuAim.cancel();
        activate(trigger, mobileQuery.matches);
      });

      trigger.addEventListener('mouseenter', function () {
        if (!mobileQuery.matches) {
          menuAim.possiblyActivate(trigger);
        }
      });

      trigger.addEventListener('focus', function () {
        // Keyboard focus is unambiguous; only pointer movement needs the
        // aim check.
        if (!mobileQuery.matches) {
          menuAim.cancel();
          activate(trigger, false);
        }
      });
    });

    // Leaving the GROUPS COLUMN kills any pending deferred activation.
    // This is what makes a successful "aim" stick: reaching the panel exits
    // the column, so the intermediate button's re-check timer must die here.
    // (The original jQuery-menu-aim binds this to its rows list for the
    // same reason.) It also covers leaving the menu entirely, since the
    // column is inside the menu.
    groupsColumn.addEventListener('mouseleave', function () {
      menuAim.cancel();
    });

    syncLayout();

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', syncLayout);
    } else {
      mobileQuery.addListener(syncLayout);
    }
  }

  function initNav(root) {
    initCartCount(root);
    initNavOpenToggle(root);
  }

  roots.forEach(function (root) {
    initNav(root);
  });

  document.querySelectorAll(selectors.menuDropdown).forEach(function (menu) {
    initMenuDropdown(menu);
  });
})();
